"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrefixLabelContainer = exports.AriaLabelContainer = exports.StyledOption = exports.MenuContainer = exports.ControllerContainer = exports.SelectContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const grey = '#D5D9D9';
const cyan = '#007185';
const setMenuPositionStyles = ({ menuPosition }) => {
    switch (menuPosition) {
        case 'top':
            return (0, styled_components_1.css) `
        bottom: 0px;
      `;
        case 'bottom':
        default:
            return (0, styled_components_1.css) `
        top: 0;
      `;
    }
};
exports.SelectContainer = styled_components_1.default.div `
  position: relative;
  ${(props) => props.fullWidth &&
    (0, styled_components_1.css) `
      width: 100%;
    `};
`;
exports.ControllerContainer = styled_components_1.default.span `
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${grey};
  border-radius: 8px;
  background: #f0f2f2;
  box-shadow: 0 2px 5px rgb(15 17 17 / 15%);
  /* height: 29px; */
  height: auto;
  font-size: 13px;
  line-height: 29px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  outline: none;
  & span,
  & i {
    padding: 0px 10px;
  }
  &:focus,
  &:active {
    border-color: ${cyan};
    box-shadow: 0 0 0 3px #c8f3fa;
  }
  &:hover {
    background: #e3e6e6;
  }
`;
exports.MenuContainer = styled_components_1.default.div `
  display: ${(props) => (props.isMenuOpen ? 'block' : 'none')};
  left: 0;
  position: absolute;
  overflow: hidden;
  border: 1px solid #cdcdcd;
  border-color: rgba(0, 0, 0, 0.2);
  height: auto;
  width: auto;
  min-width: ${(props) => (props.fullWidth ? '100%' : '140px')};
  border-radius: 4px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 13%);
  background-color: #ffffff;
  padding: 8px 0;
  z-index: 1000;
  overflow-y: auto;
  max-height: ${(props) => `${props.menuHeight}px`};
  ${setMenuPositionStyles};
  & ul {
    margin: 0;
    padding: 0;
  }
`;
exports.StyledOption = styled_components_1.default.li `
  cursor: pointer;
  color: #0f1111;
  text-decoration: none;
  padding: 2px 12px 1px 13px;
  display: block;
  white-space: nowrap;
  outline: 0;
  border: 1px solid transparent;
  font-size: 14px;
  line-height: 20px;
  &:hover {
    border-color: #d5d9d9;
    background-color: #f0f2f2 !important;
    color: inherit;
  }
  &:focus {
    border-color: ${cyan};
    background-color: #edfdff;
  }
  ${(props) => props.isActive &&
    (0, styled_components_1.css) `
      border-color: ${grey};
      background-color: #edfdff;
      border-left-color: ${cyan} !important;
    `}
  ${(props) => props.isNotValid &&
    (0, styled_components_1.css) `
      color: #bbb;
    `}
`;
exports.AriaLabelContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: 5px 10px 0px 10px;
  font-weight: bold;
  line-height: 20px;
`;
exports.PrefixLabelContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  line-height: 10px;
  padding-left: 5px;
`;
